const countryList = ['hk', 'us', 'sg', 'my']
export const genPath = (path: string) => {
  return [
    path,
    ...countryList.map(country => `/${country.toLocaleLowerCase()}${path}`),
  ]
}
